import { EvtSelect } from "components/select";
import { getDirectusField } from "directus/src/operations";
import React, { useEffect, useState } from "react";
import { useFetch } from "hooks/src/useFetch";

const TypeFilter = ({ value, onChange, ...props }) => {
  const [type, setType] = useState();

  useEffect(() => {
    if (value) {
      setType(value);
    }
  }, [value]);
  const { data, isLoading, isError } = useFetch({
    queryKey: ["job-types"],
    queryFn: async () => {
      try {
        const response = await getDirectusField("jobs", "type");

        const data = response.meta.options.choices.map((type) => {
          return { name: type.text, id: type.value };
        });
        return data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
  });

  const handleValueChange = (selectedItem) => {
    setType(selectedItem);
    onChange(selectedItem);
  };

  return (
    <EvtSelect
      placeholder="Select"
      value={type}
      onChange={handleValueChange}
      data={data}
      isLoading={isLoading}
      isError={isError}
      className="!w-full"
      {...props}
    />
  );
};

export default TypeFilter;
